import Vue from "vue";
import store from "./modules/store";
import router from "./modules/router";
import app from "./app.vue";

Vue.prototype.$store = store;
Vue.config.productionTip = false;

// import "./modules/goatcounter";
// import "./modules/fathom";
import "./modules/mixins";
import "./style/index.scss";

new Vue({
	router,
	el: "#app",
	render: (h) => h(app),
});
